import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'estadoTiempo' })
export class EstadoTiempoPipe implements PipeTransform {
  transform(value: string): string {
    const map: any = {
      DNF: 'DNF',
      DNS: 'DNS',
      DPP: 'DROP POINT'
    };

    return map[value] ?? value;
  }
}
